import React, { useEffect, useRef, useState } from "react";
import "./HealthCare.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const HealthCare = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1;

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Electronic Health Records (EHR)",
      description: "Comprehensive digital patient record systems for efficient healthcare management",
      whatsappMessage: "Hello, I'm interested in Electronic Health Records (EHR) consultation.",
    },
    {
      id: 2,
      title: "Telemedicine Platforms",
      description: "Secure virtual care solutions for remote patient consultations",
      whatsappMessage: "Hello, I'm interested in Telemedicine Platforms consultation.",
    },
    {
      id: 3,
      title: "Healthcare Analytics",
      description: "Data-driven insights for improved patient outcomes and operational efficiency",
      whatsappMessage: "Hello, I'm interested in Healthcare Analytics consultation.",
    },
    {
      id: 4,
      title: "Medical Billing Software",
      description: "Streamlined billing and revenue cycle management solutions",
      whatsappMessage: "Hello, I'm interested in Medical Billing Software consultation.",
    },
    {
      id: 5,
      title: "Patient Engagement Tools",
      description: "Solutions to improve patient communication and experience",
      whatsappMessage: "Hello, I'm interested in Patient Engagement Tools consultation.",
    },
    {
      id: 6,
      title: "Healthcare IoT",
      description: "Connected medical devices and remote patient monitoring systems",
      whatsappMessage: "Hello, I'm interested in Healthcare IoT consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="healthcare-page">
      <Helmet>
        <title>
          Healthcare Technology Solutions | Innovative Medical Technology Services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive healthcare technology solutions including EHR systems, telemedicine platforms, healthcare analytics, and patient management tools."
        />
        <meta
          name="keywords"
          content="healthcare technology, medical software, EHR systems, telemedicine, healthcare analytics, medical billing, patient engagement, healthcare IoT, HIPAA compliance, healthcare solutions, medical technology, health informatics, digital health, healthcare innovation, medical apps, healthcare data, remote patient monitoring, healthcare SaaS, medical practice management, healthcare digital transformation"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="healthcare-hero">
        <div className="healthcare-hero-content">
          <h1 className="healthcare-hero-title">
            Transforming <span className="healthcare-highlight">Healthcare Technology</span>
          </h1>
          <p className="healthcare-hero-description">
            We deliver cutting-edge healthcare solutions that transform patient care, streamline operations, and improve outcomes. From EHR systems to telemedicine platforms and AI-powered diagnostics.
          </p>
          <div className="healthcare-hero-buttons">
            <a href="/contact-us">
              <button className="healthcare-btn healthcare-btn-primary">
                Get Started
              </button>
            </a>
            <button className="healthcare-btn healthcare-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="healthcare-hero-visual">
          <div className="healthcare-animated-medical">
            <div className="healthcare-heartbeat"></div>
            <div className="healthcare-medical-cross"></div>
            <div className="healthcare-stethoscope"></div>
          </div>
          <div className="healthcare-orb healthcare-orb-1"></div>
          <div className="healthcare-orb healthcare-orb-2"></div>
          <div className="healthcare-orb healthcare-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="healthcare-services">
        <div className="healthcare-services-header">
          <h2 className="healthcare-section-title">
            Our Healthcare Solutions
          </h2>
          <p className="healthcare-section-subtitle">
            Innovative healthcare technology services designed to transform medical practices, enhance patient experiences, and improve outcomes in the digital healthcare landscape.
          </p>
        </div>

        <div className="healthcare-services-grid">
          {/* EHR Card */}
          <div className="healthcare-service-card">
            <div className="healthcare-service-icon">
              <div className="healthcare-icon healthcare-icon-ehr"></div>
            </div>
            <h3>Electronic Health Records (EHR)</h3>
            <p>
              Comprehensive digital patient record systems for efficient healthcare management and coordination.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Patient Data Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Clinical Documentation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Interoperability</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Secure Data Access</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Efficiency Gain</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99%</div>
                <div className="stat-label">Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Telemedicine Card */}
          <div className="healthcare-service-card">
            <div className="healthcare-service-icon">
              <div className="healthcare-icon healthcare-icon-telemedicine"></div>
            </div>
            <h3>Telemedicine Platforms</h3>
            <p>
              Secure virtual care solutions for remote patient consultations and monitoring.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Video Consultations</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Remote Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Prescription Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Secure Messaging</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">60%</div>
                <div className="stat-label">Cost Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">85%</div>
                <div className="stat-label">Patient Satisfaction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Healthcare Analytics Card */}
          <div className="healthcare-service-card">
            <div className="healthcare-service-icon">
              <div className="healthcare-icon healthcare-icon-analytics"></div>
            </div>
            <h3>Healthcare Analytics</h3>
            <p>
              Data-driven insights for improved patient outcomes and operational efficiency.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Population Health</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Performance Metrics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Custom Reporting</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">Better Outcomes</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Faster Decisions</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Medical Billing Card */}
          <div className="healthcare-service-card">
            <div className="healthcare-service-icon">
              <div className="healthcare-icon healthcare-icon-billing"></div>
            </div>
            <h3>Medical Billing Software</h3>
            <p>
              Streamlined billing and revenue cycle management solutions for healthcare providers.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Claims Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Payment Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Denial Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compliance Assurance</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Faster Payments</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Claim Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Patient Engagement Card */}
          <div className="healthcare-service-card">
            <div className="healthcare-service-icon">
              <div className="healthcare-icon healthcare-icon-engagement"></div>
            </div>
            <h3>Patient Engagement Tools</h3>
            <p>
              Solutions to improve patient communication, education, and experience.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Patient Portals</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Appointment Reminders</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Health Education</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Feedback Collection</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">45%</div>
                <div className="stat-label">Better Adherence</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">75%</div>
                <div className="stat-label">Satisfaction Rate</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Healthcare IoT Card */}
          <div className="healthcare-service-card">
            <div className="healthcare-service-icon">
              <div className="healthcare-icon healthcare-icon-iot"></div>
            </div>
            <h3>Healthcare IoT Solutions</h3>
            <p>
              Connected medical devices and remote patient monitoring systems for proactive care.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Wearable Devices</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Remote Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-time Alerts</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Data Integration</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Readmission Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Monitoring Efficiency</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Pharmacy Management Card */}
          <div className="healthcare-service-card">
            <div className="healthcare-service-icon">
              <div className="healthcare-icon healthcare-icon-pharmacy"></div>
            </div>
            <h3>Pharmacy Management Systems</h3>
            <p>
              Comprehensive solutions for inventory, dispensing, and pharmacy operations management.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Inventory Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Prescription Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Patient Safety Checks</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Regulatory Compliance</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">25%</div>
                <div className="stat-label">Inventory Savings</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Dispensing Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Healthcare AI Card */}
          <div className="healthcare-service-card">
            <div className="healthcare-service-icon">
              <div className="healthcare-icon healthcare-icon-ai"></div>
            </div>
            <h3>Healthcare AI & Diagnostics</h3>
            <p>
              AI-powered solutions for medical imaging, diagnostics, and treatment recommendations.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Medical Imaging Analysis</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Diagnostic Support</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Treatment Recommendations</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Risk Analysis</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Accuracy Rate</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Faster Diagnosis</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="healthcare-services-cta">
          <h3>Ready to transform your healthcare practice?</h3>
          <p>
            Schedule a free consultation with our healthcare technology experts to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="healthcare-consultation-container">
              <button
                className="healthcare-primary-btn healthcare-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="healthcare-modal-overlay">
                  <div className="healthcare-modal-content">
                    <button
                      className="healthcare-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="healthcare-modal-title">
                      Healthcare Technology Consultation
                    </h2>
                    <p className="healthcare-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="healthcare-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`healthcare-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="healthcare-option-title">
                            {option.title}
                          </h3>
                          <p className="healthcare-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`healthcare-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="healthcare-btn healthcare-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="healthcare-stats">
        <div className="healthcare-stats-container">
          <div className="healthcare-stat">
            <h3 className="healthcare-stat-number" data-count="250">
              250
            </h3>
            <p className="healthcare-stat-label">Healthcare Projects</p>
          </div>
          <div className="healthcare-stat">
            <h3 className="healthcare-stat-number" data-count="98">
              225
            </h3>
            <p className="healthcare-stat-label">Client Satisfaction</p>
          </div>
          <div className="healthcare-stat">
            <h3 className="healthcare-stat-number" data-count="15">
              11
            </h3>
            <p className="healthcare-stat-label">Years Experience</p>
          </div>
          <div className="healthcare-stat">
            <h3 className="healthcare-stat-number" data-count="40">
              40
            </h3>
            <p className="healthcare-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="healthcare-cta">
        <div className="healthcare-cta-content">
          <h2>Ready to Transform Your Healthcare Practice?</h2>
          <p>
            Contact us today to discuss how our healthcare technology expertise can help your practice innovate and improve patient care.
          </p>
          <a href="/contact-us">
            <button className="healthcare-btn healthcare-btn-primary healthcare-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default HealthCare;